export function buildParentProductComboboxItems(documents: any[]) {
  const types = (documents || []).filter(
    (row: any) => (row.record_type || "type") === "type"
  );
  const parents = (documents || []).filter(
    (row: any) => row.record_type === "parent_product"
  );

  const items: any[] = [];
  types.forEach((type: any) => {
    const children = parents.filter(
      (parent: any) => parent.parent_id === type.id
    );
    if (children.length === 0) {
      return;
    }
    items.push({
      isGroup: true,
      label: type.name
    });
    children.forEach((parent: any) => {
      items.push({
        id: parent.id,
        label: parent.name,
        isChild: true
      });
    });
  });

  const typedIds = new Set(types.map((t: any) => t.id));
  const orphans = parents.filter(
    (parent: any) => !typedIds.has(parent.parent_id)
  );
  if (orphans.length > 0) {
    items.push({ isGroup: true, label: "Без типа" });
    orphans.forEach((parent: any) => {
      items.push({
        id: parent.id,
        label: parent.name,
        isChild: true
      });
    });
  }

  return items;
}
